import { render, staticRenderFns } from "./GalleryProperty.vue?vue&type=template&id=9894128c&scoped=true"
import script from "./GalleryProperty.vue?vue&type=script&lang=js"
export * from "./GalleryProperty.vue?vue&type=script&lang=js"
import style0 from "./GalleryProperty.vue?vue&type=style&index=0&id=9894128c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9894128c",
  null
  
)

export default component.exports